import React from 'react';
import { Cards } from '../Card/Card';

const InvoicesOverview = ({invSummary}) => (
  <Cards cards={invSummary}/>
);

export default InvoicesOverview;
